<template>
    <div class="gcmcn-card related-user">
        <loader
            v-if="loading && isEntityRelated"
        ></loader>
        <el-row :gutter="0">
            <el-col :span="15">
                <div class="name">{{ user.email }}</div>
            </el-col>
            <el-col :span="9">
                <div class="actions text-right">
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn taker-user-btn"
                        icon="el-icon-key"
                        @click="changeUserPassword"
                    ></el-button>
                    <el-popover
                        ref="popover"
                        placement="bottom"
                        width="150"
                        trigger="click"
                        popper-class="dark-popper"
                    >
                        <div>
                            <div class="popover-title">ARE YOU SURE ABOUT DELETING THIS USER ?</div>
                            <div class="actions">
                                <el-button
                                    type="text"
                                    class="decline"
                                    @click="hidePopover()"
                                >No</el-button>
                                <el-button
                                    type="text"
                                    class="accept"
                                    @click="deleteUser"
                                >Yes</el-button>
                            </div>
                        </div>
                        <el-button
                            slot="reference"
                            style="margin-left: 10px;"
                            type="primary"
                            class="gcmcn-primary-btn taker-user-btn"
                            icon="el-icon-delete"
                        ></el-button>
                    </el-popover>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Loader from '@/components/loader-template.vue';
export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        isEntityRelated:{
            type: Boolean,
            default: false,
        }
    },
    components:{
        Loader
    },
    data (){
        return {
            loading: false,
        };
    },
    computed: {
    },
    methods: {
        changeUserPassword() {
            this.$emit('editUserPassword', this.user);
        },
        resetLoading(){
            this.loading = false;
        },
        deleteUser() {
            if(this.isEntityRelated){
                this.hidePopover();
                this.loading = true;
            }
            this.$emit('deleteUser', this.user.uid);
        },

        hidePopover() {
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.related-user {
    &.related-user {
        margin-top: 10px;
    }
    .taker-user-btn{
        font-size: 15px;
    }
    .loading-spinner-container{
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/relatedUser.vue